
import { base64Decode } from '@/utils/crypto'

const getters = {
  token: state => base64Decode(state.user.token),
  avatar: state => state.user.avatar,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  welcome: state => state.user.welcome,
  config: state => state.user.config,
  roles: state => state.user.roles,
  depts: state => state.user.depts,
  info: state => state.user.info,
}

export default getters